import { Platform } from "react-native"

import * as Haptics from "expo-haptics"
import { Instance, types } from "mobx-state-tree"

import { withSetPropAction } from "./helpers/withSetPropAction"

export const TypingStoreModel = types
  .model("TypingStore")
  .props({
    incomingMessage: types.optional(types.string, ""),
    hapticsEnbaled: types.optional(types.boolean, false), // Start with Haptics off for messages.
  })
  .actions(withSetPropAction)
  .actions((self) => ({
    appendString(word: string) {
      if (self.hapticsEnbaled && !(Platform.OS === "web")) {
        Haptics.impactAsync(Haptics.ImpactFeedbackStyle.Light)
      }

      self.incomingMessage += word
    },
    resetString() {
      self.incomingMessage = ""
    },
    getMessageValue() {
      return self.incomingMessage
    },
    setHapticsEnabled(value: boolean) {
      self.hapticsEnbaled = value
    },
  }))

export interface TypingStore extends Instance<typeof TypingStoreModel> {}
